import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-offonline",
  "use": "icon-offonline-usage",
  "viewBox": "0 0 69.7 69.7",
  "content": "<symbol viewBox=\"0 0 69.7 69.7\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-offonline\"><path d=\"m21.4 46.4-5.8-5.8c3.3-3.3 7.3-5.6 11.5-6.9l.3 8.7c-2.3.9-4.3 2.2-6 4zm-11-11c4.7-4.7 10.4-7.7 16.4-9.2l-.2-8.4c-8.1 1.6-15.7 5.6-22 11.8zm33.4-17.6-.3 8.4c6 1.5 11.7 4.5 16.4 9.2l5.8-5.8c-6.1-6.2-13.8-10.2-21.9-11.8zm-.5 15.8-.3 8.7c2.2 1 4.2 2.3 6 4.1l5.8-5.8c-3.3-3.4-7.2-5.7-11.5-7zm-8.1 26c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5zm-2-14.1h4c1 0 1.9-.8 1.9-1.9l1-31.7c0-1.1-.8-2-1.9-2h-5.9c-1.1 0-1.9.9-1.9 2l.9 31.7c0 1.1.9 1.9 1.9 1.9z\" fill=\"#d0d4d7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/offonline.svg
// module id = Mj4q
// module chunks = 103